<template>
    <form class="form-inline w-100 root">
        <div class="form-group has-search w-100 d-flex align-items-center position-relative">
            <span class="fa fa-search form-control-feedback"></span>
            <input
                v-model="formData.input"
                id="searchInput"
                type="search"
                class="form-control w-100"
                style="border-radius: 25px !important;"
                placeholder="Search"
                @keyup="search"
                @input="reset"
                @focus="focus"
            >
            <div v-if="focused" class="search_result">
                <app-pre-loader v-if="loading" />
                <template v-else>
                    <div v-for="(item, index) in result" class="search_result__item d-flex align-items-center gap-x-1 py-1" :key="`search-result-${item.id}`">
                        <img width="60" height="60" class="rounded-circle" :src="item?.profile_picture?.full_url || urlGenerator('/images/avatar-demo.jpg')" alt="">
                        <div>
                            <a class="btn btn-link px-0" :href="urlGenerator('/profile/' + item.uuid)" target="_blank">{{ item.full_name }}</a>
                            <div v-if="item.teams.length" class="d-flex align-items-center flex-wrap gap-x-1 gap-y-1">
                                <div class="badge badge-primary badge-sm badge-pill" v-for="(team) in item.teams" :key="`team-item-${team.id}-${item.id}`">{{ team.name }}</div>
                            </div>
                        </div>
                    </div>
                </template>
                <app-empty-data-block v-if="!result.length && !loading" :message="$t('empty_data_block_dummy_message')"/>
            </div>
        </div>
        <div v-if="focused" @click.self="blur" class="search_result__backdrop"></div>
    </form>
</template>

<script>
import axios from "axios";
import {SEARCH} from "../../config/ApiUrl";
import {urlGenerator} from "../../helpers/AxiosHelper";
export default {
    data() {
        return {
            urlGenerator,
            formData: {
                input: ''
            },
            focused: false,
            result: [],
            loading: false,
            params: {
                page: 1,
                per_page: 5,
            }
        }
    },
    methods: {
        search: _.debounce(function (e) {
            let searchText = e.target.value
            if(searchText === ''){
                this.result = []
                return
            }
            this.loading = true
            axios.get(urlGenerator(SEARCH+ window.user.id), {params: { search: searchText ,...this.params}}).then(res => {
                this.result = res.data.data
            }).catch(err => {})
            .finally(() => { this.loading = false })
        }, 500),
        focus(e) {
            this.focused = true
        },
        blur(e) {
            this.result = []
            this.formData.input = ''
            this.focused = false
        },
        reset(e) {
            let value = e.target.value
            if(!value){
                this.result = []
            }
        }
    }
}
</script>

<style scoped lang="scss">
.has-search .form-control {
    padding-left: 2.375rem !important;
    z-index: 500;
}

.has-search .form-control-feedback {
    position: absolute !important;
    z-index: 2 !important;
    display: block !important;
    width: 2.375rem !important;
    height: 2.375rem !important;
    line-height: 2.375rem !important;
    text-align: center !important;
    pointer-events: none !important;
    color: #999;
}
.search_result{
    display: flex;
    flex-direction: column;
    position: absolute;
    gap: 10px;
    top: 50px;
    width: 100%;
    //background-color: #fffffff1;
    z-index: 500;
    &__item{
        padding: 5px 15px;
        //background-color: #ffffff;
        border-radius: 15px;
        //border: 1px solid #dddddd
    }
    &__backdrop{
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #ffffff90;
        //background-color: #00000090;
        z-index: 400;
        backdrop-filter: blur(6px);
    }
}
</style>